const env = 'prod';
export const API_URL = `https://api.flyoutacademy.co.uk/${env}`;